export const MOST_REQUESTED_SERVICES = [
  {
    id: 'grah-shanti-service',
    title: 'Grah Shanti Pooja',
    category: 'Home Rituals',
    aliases: ['Grah Shanti', 'Graha Shanti', 'Navgraha Shanti'],
    image: '🪔',
    description: 'Planetary peace and dosha balancing rituals with guided sankalp.',
    duration: '2 to 4 hours',
    rating: 4.8,
    reviews: 260,
    price: 2499,
    demandScore: 95
  },
  {
    id: 'griha-pravesh-service',
    title: 'Griha Pravesh Pooja',
    category: 'Home Rituals',
    aliases: ['Grah Pravesh', 'Housewarming Puja'],
    image: '🏠',
    description: 'Housewarming rituals with multi-day and pandit-team options.',
    duration: '1 to 9 days',
    rating: 4.9,
    reviews: 410,
    price: 2598,
    demandScore: 98
  },
  {
    id: 'satyanarayan-service',
    title: 'Satyanarayan Pooja',
    category: 'Spiritual',
    aliases: ['Satyanarayan Katha', 'Satyanarayan Puja'],
    image: '📿',
    description: 'Traditional Satyanarayan katha with transparent pricing and add-ons.',
    duration: '2 to 2.5 hours',
    rating: 4.8,
    reviews: 370,
    price: 1598,
    demandScore: 96
  },
  {
    id: 'bhagwat-katha-service',
    title: 'Bhagwat Katha',
    category: 'Katha',
    aliases: ['Bhagavat Katha', 'Shrimad Bhagwat Katha'],
    image: '📖',
    description: 'Devotional katha formats for 1 to 7 days with scalable pandit team.',
    duration: '1 to 7 days',
    rating: 4.9,
    reviews: 340,
    price: 10497,
    demandScore: 97
  },
  {
    id: 'ramayan-katha-service',
    title: 'Ramayan Katha',
    category: 'Katha',
    aliases: ['Ram Katha', 'Akhand Ramayan Path'],
    image: '🏹',
    description: 'Traditional ramayan path and katha with curated event support.',
    duration: '1 to 7 days',
    rating: 4.8,
    reviews: 290,
    price: 8997,
    demandScore: 93
  },
  {
    id: 'sundar-kand-service',
    title: 'Sundar Kand Path',
    category: 'Path',
    aliases: ['Sunder Kand Path', 'Sundarkand'],
    image: '🙏',
    description: 'Focused path session for protection and positivity rituals.',
    duration: '2 to 4 hours',
    rating: 4.8,
    reviews: 310,
    price: 1999,
    demandScore: 94
  },
  {
    id: 'shravan-anushtan-service',
    title: 'Shravan Puja Anushtan',
    category: 'Seasonal',
    aliases: ['Sawan Puja', 'Shravan Anushthan'],
    image: '🌿',
    description: 'Shravan-specific anusthan plans with flexible pandit team sizes.',
    duration: '1 to 3+ days',
    rating: 4.9,
    reviews: 220,
    price: 10497,
    demandScore: 92
  },
  {
    id: 'mahamrityunjay-jaap-service',
    title: 'Mahamrityunjay Jaap',
    category: 'Jaap',
    aliases: ['Maha Mrityunjay Jaap', 'Mrityunjay Jaap'],
    image: '🕉️',
    description: '31k to 1 lakh+ jaap options with transparent package-wise pricing.',
    duration: '1 to 3+ days',
    rating: 4.9,
    reviews: 280,
    price: 18999,
    demandScore: 95
  },
  {
    id: 'satchandi-havan-service',
    title: 'Satchandi Havan',
    category: 'Havan',
    aliases: ['Chandi Havan', 'Sat Chandi Path'],
    image: '🔥',
    description: 'Laghu, Madhyam, and Maha anusthan options with pandit-based pricing.',
    duration: '1 to 3+ days',
    rating: 4.8,
    reviews: 190,
    price: 6197,
    demandScore: 91
  },
  {
    id: 'rudrabhishek-service',
    title: 'Rudrabhishek',
    category: 'Shiva Rituals',
    aliases: ['Rudra Abhishek', 'Mahadev Abhishek'],
    image: '🔱',
    description: 'Powerful Shiva ritual with transparent charges and upgrade options.',
    duration: '3 to 4 hours',
    rating: 4.9,
    reviews: 250,
    price: 3148,
    demandScore: 90
  },
  {
    id: 'hanuman-chalisa-service',
    title: 'Hanuman Chalisa Path',
    category: 'Path',
    aliases: ['Hanuman Chalisa Jaap', 'Chalisa Path'],
    image: '🐒',
    description: 'Protective and devotional path with optional extended jaap support.',
    duration: '1 to 2 hours',
    rating: 4.8,
    reviews: 210,
    price: 1499,
    demandScore: 88
  }
];

export const DEMAND_HIGHLIGHTED_SERVICES = [...MOST_REQUESTED_SERVICES]
  .sort((a, b) => Number(b.demandScore || 0) - Number(a.demandScore || 0));
